import ContextMenu from "./ContextMenu";
import { useState } from 'react';

export default function ContextMenuTrigger({
  unifiedGroup,
  figurePanelId,
  setSelectedCells,
  selectedFigureItems,

}){
  const [ menuOpen, setMenuOpen ] = useState(false);

  const cellsSelected = (
    selectedFigureItems?.cells?.length > 0
  );

  if( !cellsSelected && menuOpen ){
    setMenuOpen(false);
  }


  return (
    <div class={`${cellsSelected ? "hoverable round-corners" : "disabled-button"}`} style={{
      zIndex:2,
      padding:5,
    }}

    onClick={() => {
        setMenuOpen(!menuOpen);
      }}
    >
      <div>Actions</div>
      {menuOpen && (<ContextMenu {...{

        unifiedGroup,
        figurePanelId,
        setSelectedCells,
        selectedFigureItems,
        onClose:() => setMenuOpen(false)


      }}/>)}
    </div>
  )
}
